import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import CaretDownIcon from '@patternfly/react-icons/dist/js/icons/caret-down-icon';
import styles from '@patternfly/react-styles/css/components/ContextSelector/context-selector';
import { css } from '@patternfly/react-styles';
import { KEY_CODES } from '../../helpers/constants';
export var ContextSelectorToggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContextSelectorToggle, _React$Component);

  function ContextSelectorToggle() {
    var _this;

    _classCallCheck(this, ContextSelectorToggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContextSelectorToggle).apply(this, arguments));
    _this.toggle = React.createRef();

    _this.componentDidMount = function () {
      document.addEventListener('mousedown', _this.onDocClick);
      document.addEventListener('touchstart', _this.onDocClick);
      document.addEventListener('keydown', _this.onEscPress);
    };

    _this.componentWillUnmount = function () {
      document.removeEventListener('mousedown', _this.onDocClick);
      document.removeEventListener('touchstart', _this.onDocClick);
      document.removeEventListener('keydown', _this.onEscPress);
    };

    _this.onDocClick = function (event) {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          parentRef = _this$props.parentRef,
          onToggle = _this$props.onToggle;

      if (isOpen && parentRef && !parentRef.contains(event.target)) {
        onToggle(null, false);

        _this.toggle.current.focus();
      }
    };

    _this.onEscPress = function (event) {
      var _this$props2 = _this.props,
          isOpen = _this$props2.isOpen,
          parentRef = _this$props2.parentRef,
          onToggle = _this$props2.onToggle;
      var keyCode = event.keyCode || event.which;

      if (isOpen && keyCode === KEY_CODES.ESCAPE_KEY && parentRef && parentRef.contains(event.target)) {
        onToggle(null, false);

        _this.toggle.current.focus();
      }
    };

    _this.onKeyDown = function (event) {
      var _this$props3 = _this.props,
          isOpen = _this$props3.isOpen,
          onToggle = _this$props3.onToggle,
          onEnter = _this$props3.onEnter;

      if (event.keyCode === KEY_CODES.TAB && !isOpen || event.key !== KEY_CODES.ENTER) {
        return;
      }

      event.preventDefault();

      if ((event.keyCode === KEY_CODES.TAB || event.keyCode === KEY_CODES.ENTER || event.key !== KEY_CODES.SPACE) && isOpen) {
        onToggle(null, !isOpen);
      } else if ((event.keyCode === KEY_CODES.ENTER || event.key === ' ') && !isOpen) {
        onToggle(null, !isOpen);
        onEnter();
      }
    };

    return _this;
  }

  _createClass(ContextSelectorToggle, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          toggleText = _a.toggleText,
          isOpen = _a.isOpen,
          onToggle = _a.onToggle,
          id = _a.id,
          isActive = _a.isActive,
          onEnter = _a.onEnter,
          parentRef = _a.parentRef,
          props = __rest(_a, ["className", "toggleText", "isOpen", "onToggle", "id", "isActive", "onEnter", "parentRef"]);

      return React.createElement("button", Object.assign({}, props, {
        id: id,
        ref: this.toggle,
        className: css(styles.contextSelectorToggle, isActive && styles.modifiers.active, className),
        type: "button",
        onClick: function onClick(event) {
          return onToggle(event, !isOpen);
        },
        "aria-expanded": isOpen,
        onKeyDown: this.onKeyDown
      }), React.createElement("span", {
        className: css(styles.contextSelectorToggleText)
      }, toggleText), React.createElement("span", {
        className: css(styles.contextSelectorToggleIcon)
      }, React.createElement(CaretDownIcon, {
        "aria-hidden": true
      })));
    }
  }]);

  return ContextSelectorToggle;
}(React.Component);
ContextSelectorToggle.defaultProps = {
  className: '',
  toggleText: '',
  isOpen: false,
  onEnter: function onEnter() {
    return undefined;
  },
  parentRef: null,
  isActive: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onToggle: function onToggle(event, value) {
    return undefined;
  }
};